import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

export default function TermsPage() {
  const { t } = useTranslation()
  return (
    <main className="max-w-2xl mx-auto px-4 py-10 pb-32">
      <Link to="/" className="inline-flex items-center min-h-[48px] px-2 text-primary-text hover:underline mb-6">
        ← {t('terms.back')}
      </Link>
      <h1 className="text-2xl font-bold text-fg mb-6">{t('terms.title')}</h1>

      <section className="space-y-4 text-muted text-base leading-relaxed">
        <h2 className="text-lg font-semibold text-fg">{t('terms.pricesTitle')}</h2>
        <p>{t('terms.pricesBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.sourceTitle')}</h2>
        <p>{t('terms.sourceBody')}</p>
        <p>
          <Trans
            i18nKey="terms.sourceCrawler"
            components={{
              crawlerLink: (
                <a
                  href="https://github.com/senko/cijene-api"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-text underline"
                />
              ),
            }}
          />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.availabilityTitle')}</h2>
        <p>{t('terms.availabilityBody')}</p>

        <h2 className="text-lg font-semibold text-fg">{t('terms.ipTitle')}</h2>
        <p>{t('terms.ipBody')}</p>
      </section>
    </main>
  )
}
